import React from "react";
import { Link } from "react-router-dom";
import "./GestionInstructor.css";
import ResponsiveActionSidebar from "../components/ResponsiveActionSidebar";

const LABEL_REGISTRO_E_INVITACION_PAGO = "Registrar usuario / Invitación de pago";

const GestionInstructor = () => {
  const links = [
    { path: "/Registrousuario", label: LABEL_REGISTRO_E_INVITACION_PAGO },
    { path: "/GestionCursos", label: "Gestionar cursos" },
    { path: "/instructor/progreso-alumnos", label: "Seguimiento de alumnos" },
    { path: "/GestionAnuncios", label: "Comunicados por curso" },
    { path: "/mensajeria-interna", label: "Mensajería corporativa" },
  ];

  return (
    <div className="gi-container">
      <div className="gi-main-container">
        <div className="gi-content">
          <div className="gi-titulo titulo-instructor">
            <h1 className="gi-texto">Centro del instructor</h1>
          </div>
          <br />
          <h2>Bienvenido</h2>
          <br />
          <p>
            Tu perfil está centrado en el contenido de los cursos: edición, materiales, documentos y tests
            los gestionas desde <strong>Gestionar cursos</strong> (elige un curso y pulsa <strong>Gestionar curso</strong>{" "}
            para abrir el editor, o <strong>Visualizar curso</strong> para previsualizar).
          </p>
          <p>
            En <strong>Acciones</strong> tienes el enlace <strong>{LABEL_REGISTRO_E_INVITACION_PAGO}</strong> para dar
            de alta alumnos e invitaciones al pago en los cursos en los que eres administrador. No tienes acceso a la gestión
            global de la
            plataforma (usuarios globales, configuración, pagos centralizados ni comunicados corporativos).
          </p>
        </div>
        <ResponsiveActionSidebar
          id="gi-instructor-sidebar"
          className="gi-sidebar"
          openClassName="gi-sidebar--open"
          toggleClassName="gi-sidebar-toggle"
          label="Menú"
          ariaLabel="Acciones del instructor"
        >
          <h4 className="gi-sidebar-title">Acciones</h4>
          <ul className="gi-links">
            {links.map((link) => (
              <li key={link.path} className="gi-link-item">
                <Link to={link.path} className="gi-link">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </ResponsiveActionSidebar>
      </div>
    </div>
  );
};

export default GestionInstructor;
